/**
 * @Description: 学院报到人数
 * @Version: 1.0
 * @Author: 琴时
 * @Date: 2021-09-09 14:20:30
 * @LastEditors: 琴时
 * @LastEditTime: 2021-09-24 13:49:32
 * @FilePath: \ly-sm-yxxt-ui\src\containers\Show-new\_LeftBottomBox.js
 */
import React from 'react'
import ReactEchartsCore from 'echarts-for-react/lib/core'
import echarts from 'echarts/lib/echarts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'

import 'echarts/lib/chart/bar'
import styles from './styles.css'
import NHFetch from '../../utils/NHFetch.js'

const yxxtBasicUrl = 'api/zhxg-yxxt' //迎新管理服务后台接口基础路径
const errMaxCount = 3 // 请求异常最大次数
const speed = 60 * 1000 //轮询时间间隔
const pageSize = 15 //分页显示每页数据数量

export default class _RightBottomBox extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      errCount: 0, //连续请求错误次数
      barData: [], //各学院报到统计数据
      page: 0, //当前显示的页数
      activeBarData: [], //当前显示的数据
    }
    this.polling
    this.activePolling
  }

  componentDidMount() {
    this.getData()
  }

  componentWillUnmount() {
    if (this.polling) {
      clearTimeout(this.polling)
    }
    if (this.activePolling) {
      clearInterval(this.activePolling)
    }
  }

  getData = () => {
    NHFetch(yxxtBasicUrl + '/sstj/getDepartmentReportedSituationByLcid', 'GET',{pkid: this.props.pkid})
      .then(res => {
        if (res && res.data) {
          this.polling = setTimeout(() => {
            this.getData()
          }, speed)

          let data = res.data
          let barData = []
          let pageItems = []

          //如果数据量超过每页最大显示数量，则做分页显示处理
          data.map((item, index) => {
            pageItems.push(item)

            if ((index + 1) % pageSize == 0 || index == data.length - 1) {
              barData.push(pageItems)
              pageItems = []
            }
          })

          this.setState(
            { errCount: 0, barData: barData, activeBarData: barData[0] },
            () => {
              if (this.activePolling) {
                clearInterval(this.activePolling)
              }

              //隔5秒换页
              this.activePolling = setInterval(() => {
                let { page, barData } = this.state
                const length = barData.length

                if (page + 1 >= length) {
                  page = 0
                } else {
                  page += 1
                }
                let activeBarData = barData[page]

                this.setState({ page, activeBarData })
              }, 5000)
            }
          )
        }
      })
      .catch(err => {
        let errCount = this.state.errCount
        //如果请求异常次数未超过最大次数限制，则继续尝试
        if (errCount < errMaxCount) {
          this.polling = setTimeout(() => {
            this.getData()
          }, speed)
          this.setState({ errCount: errCount + 1 })
        } else {
          //异常超过3次后终止轮询
          if (this.polling) {
            clearTimeout(this.polling)
          }
          if (this.activePolling) {
            clearInterval(this.activePolling)
          }
        }
      })
  }

  /**
   * * 构造学院报到率条形统计图
   */
  getBarOption = () => {
    const { rem } = this.props
    let { activeBarData = [] } = this.state
    // y轴系列（学院名称）
    let college = activeBarData.map(item => {
      return item.xymc
    })

    //报到人数
    let bdrs = activeBarData.map(item => {
      return item.bdrs
    })

    //报到率
    let bdl = activeBarData.map(item => {
      return item.bdl
    })
    //总人数人数
    let xyrs = activeBarData.map(item => {
      return item.xyrs
    })

    //未报到率
    let wbdl = activeBarData.map(item => {
      return item.wbdl
    })

    const option = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
        },
        formatter: function (params) {
          return `${params[0].seriesName}: ${bdrs[params[0].dataIndex]}<br />${
            params[1].seriesName
          }: ${xyrs[params[1].dataIndex]}`
        },
      },
      legend: {
        data: ['已报到人数', '总人数'],
        top: '4%',
        itemWidth: 0.25 * rem,
        itemHeight: 0.14 * rem,
        textStyle: {
          color: '#fff',
          fontSize: 0.16 * rem,
        },
      },
      grid: {
        top: '8%',
        left: '1%',
        right: '15%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: {
        type: 'value',
        interval: 50,
        max: 100,
        axisLabel: {
          formatter: function (value) {
            return value + '%'
          },
          show: true,
          color: '#fff',
          fontSize: 0.14 * rem,
        },
        axisLine: {
          lineStyle: {
            color: '#fff',
          },
        },
        splitLine: false,
      },
      yAxis: {
        type: 'category',
        axisLabel: {
          show: true,
          color: '#FFFFFF',
          fontSize: 0.14 * rem,
          formatter: (value, index) => {
            //学院名字过长时，超过7个字则换行
            let titleStr = []
            if (value.length > 0) {
              let count = parseInt(value.length / 7) + 1
              for (let i = 0; i < count; i++) {
                titleStr.push(value.substr(i * 7, 7))
              }
            }

            return titleStr.length > 1 ? titleStr.join('\n') : titleStr.join('')
          },
        },
        axisLine: false,
        data: college,
      },
      series: [
        {
          name: '已报到人数',
          type: 'bar',
          barMaxWidth: 0.14 * rem,
          stack: '总量',
          barCategoryGap: '53%',
          z: 11, //让label数值悬浮在上方
          label: {
            normal: {
              formatter: function (data) {
                return bdrs[data.dataIndex]
              },
              show: true,
              fontSize: 0.14 * rem,
              position: 'insideLeft',
            },
          },

          itemStyle: {
            normal: {
              color: {
                type: 'bar',
                colorStops: [
                  {
                    offset: 0,
                    color: '#fa947a', // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: '#f85848', // 100% 处的颜色
                  },
                ],
                globalCoord: false, // 缺省为 false
              },
              borderType: 'solid',
              borderWidth: 1,
              borderColor: '#fff',
            },
          },
          data: bdl.map((item, index) => {
            const value = parseFloat(item * 100).toFixed(2)
            return value
          }),
        },
        {
          name: '总人数',
          type: 'bar',
          barMaxWidth: 0.24 * rem,
          stack: '总量',
          label: {
            normal: {
              formatter: function (data) {
                let label = `{lg|${xyrs[data.dataIndex]}}  {rg|${parseFloat(
                  bdl[data.dataIndex] * 100
                )}%}`
                return label
              },
              rich: {
                lg: {
                  color: '#2BA8FF',
                  fontSize: 0.14 * rem,
                },
                rg: {
                  color: '#2FFDFF',
                  fontSize: 0.14 * rem,
                },
              },
              show: true,
              position: 'right',
            },
          },
          itemStyle: {
            normal: {
              color: '#0e3a76',
              borderType: 'solid',
              borderWidth: 1,
              borderColor: '#fff',
            },
          },
          data: wbdl.map(item => {
            const value = parseFloat(item * 100).toFixed(2)
            return value
          }),
        },
      ],
    }

    return option
  }

  render() {
    return (
      <div className='rightTopBox' style={{ width: '100%', height: '100%' }}>
        <span className={styles.box_title} style={{ top: '2px' }}>
          学院报到
        </span>
        <ReactEchartsCore
          style={{ width: '100%', height: '100%' }}
          echarts={echarts}
          option={this.getBarOption()}
          notMerge={true}
          lazyUpdate={true}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./containers/Show-new/_LeftBottomBox.js